import { TerciarySmallButton } from 'components/ReusableComponents/Button/SmallButtons'
import CopyIcon from 'components/ReusableComponents/Icons/CopyIcon'
import { Cell, Row } from 'components/ReusableComponents/Table'
import NormalCell from 'features/Users/NormalCell'
import useCopyText from 'hooks/useCopyText'
import Moment from 'moment'
import { useState } from 'react'

import HotelsTooltip from './HotelsTooltip'
import styles from './Users.module.scss'

const timezoneShortNames = {
  '-4': 'AST',
  '-5': 'EST',
  '-6': 'CST',
  '-7': 'MST',
  '-8': 'PST',
  '-9': 'AKST',
  '-10': 'HAST'
}

const UserRow = ({
  fullName,
  email,
  phone,
  subsidiaries,
  addedOn,
  userId,
  utcOffSet,
  onEditClick
}) => {
  const copy = useCopyText()

  const [isTooltipVisible, setIsTooltipVisible] = useState(false)

  return (
    <Row>
      <Cell className={styles.nameCell}>
        <span>{fullName}</span>
      </Cell>
      <NormalCell>
        <span
          title={email}
          style={{
            cursor: 'pointer',
            maxWidth: 150,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            display: 'inline-block'
          }}
          onClick={() => copy(email)}
        >
          {email}
        </span>
      </NormalCell>
      <NormalCell>
        <span style={{ cursor: 'pointer' }} onClick={() => copy(phone)}>
          {' '}
          {phone}
        </span>
      </NormalCell>
      <NormalCell>
        <span>{utcOffSet ? timezoneShortNames[utcOffSet] : '-'}</span>
      </NormalCell>
      <Cell className={styles.subsidiariesCell}>
        {subsidiaries?.length ? (
          <div
            onMouseOver={() =>
              subsidiaries?.length > 1 ? setIsTooltipVisible(true) : false
            }
            onMouseOut={() => setIsTooltipVisible(false)}
            className={styles.tooltipHolder}
          >
            <span className={styles.subsidiaryName}>
              <div className={styles.pill}>{subsidiaries.length}</div>
              {subsidiaries?.[0].subsidiaryName}{' '}
            </span>

            {isTooltipVisible && <HotelsTooltip hotelsArray={subsidiaries} />}
          </div>
        ) : (
          '-'
        )}
      </Cell>
      <NormalCell>{Moment(addedOn).format('MMM DD, YYYY')}</NormalCell>
      <Cell className={styles.copyCell}>
        <button className={styles.copyButton} onClick={() => copy(userId)}>
          <CopyIcon />
        </button>
      </Cell>
      <Cell className={styles.goCell}>
        <TerciarySmallButton onClick={onEditClick}>Edit</TerciarySmallButton>
      </Cell>
    </Row>
  )
}

export default UserRow
